export enum SalesCampaignCartRuleAssortmentConstraintTypeEnum {
  Quantity = 1,
  Value = 2,
}
